module.exports = "/_next/static/files/90b619e0c0ed1573db8c737f32acfaea.svg";